import { render, staticRenderFns } from "./fileHistoryTab.vue?vue&type=template&id=0bd8caf8&scoped=true&"
import script from "./fileHistoryTab.vue?vue&type=script&lang=js&"
export * from "./fileHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd8caf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd8caf8')) {
      api.createRecord('0bd8caf8', component.options)
    } else {
      api.reload('0bd8caf8', component.options)
    }
    module.hot.accept("./fileHistoryTab.vue?vue&type=template&id=0bd8caf8&scoped=true&", function () {
      api.rerender('0bd8caf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/financeManage/fileHistoryTab.vue"
export default component.exports